import React from 'react';

import { Typography } from '@material-ui/core';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';

import useStyles from './styles';

interface ResultsTitleProps {
  isSuccessful?: boolean;
  wrapperClass?: string;
}

const ResultsTitle: React.FC<ResultsTitleProps> = ({ isSuccessful = false, wrapperClass }) => {
  const classes = useStyles(isSuccessful)();
  const { t } = useTranslation();

  return (
    <Typography data-testid="resultTestTitle" className={cx(classes.title, wrapperClass)}>
      {isSuccessful ? t('page.pathway.congratulations') : t('page.pathway.unsuccessful')}
    </Typography>
  );
};

export default ResultsTitle;
